import { Button } from '@mui/material'
import { useCallback } from 'react'

import { MetalworksAnalytics, analyticsService } from '../../systems/analytics'
import { configuratorInterface } from '../../systems/configurator-interface'
import { getQuoteId } from '../../systems/metalworks-api'

export const StartNewButton = () => {
  const { configurationId } = configuratorInterface.useDomain()

  const handleStartNew = useCallback(async () => {
    analyticsService.push(MetalworksAnalytics.CreateNewConfigurationButtonClicked())

    const quoteId = getQuoteId(configurationId)

    if (quoteId != null) {
      location.href = `/?quoteId=${quoteId}`
    } else {
      location.href = `/`
    }
  }, [configurationId])

  return (
    <Button variant="contained" onClick={handleStartNew}>
      Start new
    </Button>
  )
}
